import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent, SnackbarCommonComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import EmployerRegisterComponent from "../components/employer/employerRegisterComponent";
import { SessionUserStyles } from "./PagesStyle";
import { mapMessageCodeToIcon } from "../helpers/extensions";
import { cleanMessage } from "../actions/EmployerActions";

class EmployerRegisterPage extends Component {
	render() {
		const {
			classes, isLoading, message, messageCode, cleanMessageInternal, mixpanel
		} = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<SidebarComponent />
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<SnackbarCommonComponent key="SnackBarUpdateEmployer" variant={mapMessageCodeToIcon(messageCode)} open={(!!message)} body={message} onCloseModal={cleanMessageInternal} />
					<div className={classes.appBarSpacer} />
					<EmployerRegisterComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

EmployerRegisterPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool,
	messageCode: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	message: PropTypes.string
};

const mapStateToProps = state => ({
	isLoading: state.employer.isLoading,
	messageCode: state.employer.messageCode,
	message: state.employer.message
});

const mapDispatchToProps = dispatch => ({
	cleanMessageInternal: bindActionCreators(cleanMessage, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(SessionUserStyles)(EmployerRegisterPage));
